import React, { FC } from 'react';
import classNames from 'classnames';
import { CardSection, CardSectionProps } from './CardSection';

interface CardFooterProps extends CardSectionProps {}

export const CardFooter: FC<CardFooterProps> = ({ className, ...props }) => (
  <CardSection className={classNames('card__footer flex-grow-0', className)} {...props} />
);
